import { SAColumns, SAIcon, SAIcons, SAModal, SATabBar } from '@saux/design-system-react'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { CONVERSATION_CONTROL_TABS, RECEIVED, SEND } from '../../utils/constants';
import AllConversations from '../allConversations/AllConversations';
import MyConversations from '../myConversations/MyConversations';
import { handleSubscriptionError, setAlert, simpleGTMDataLayer, twoStringsAreEqual } from '../../utils/utilities';
import { useDispatch, useSelector } from 'react-redux';
import fetchConversations, { fetchUnreadMessagesCountById } from '../../store/actions/conversationActions';
import { updateInitialState } from '../../store/action-creators/conversationActionCreator';
import { executeGraphqlSubscribe } from '../../graphql/api';
import { loader } from 'graphql.macro';
const receiveMessagesSubscription = loader(
  "../../graphql/subscriptions/receiveMessagesByAdjusterId.graphql"
);

const Container = styled.div`
    padding: 30px;
    nav{
      ul{
        width:100%;
        li{
          width:33%;
          text-align:center;
        }
      }
    }
`;

const TabBar = styled(SATabBar)`
  li {
    width: 25% !important;
    margin: 0;
  }

  li button{
    cursor: pointer !important;
   }
  
  li.active {
    border-bottom: 4px solid rgb(77, 132, 11);
    button{
      font-weight: 700;
      border-bottom:none;
    }
  }
`;

export default function ConversationControl(props: any) {
  const [activeIndex, setActiveIndex] = useState(0);
  const user = useSelector((state: any) => state.user)
  const itemLabels = Object.values(CONVERSATION_CONTROL_TABS);
  const dispatch = useDispatch();
  let messageSubscription: any;

  useEffect(() => {
    subscribeToMessage();
    setActiveIndex(0);
    dispatch(fetchConversations({ adjusterId: user?.email, isArchived: false },
        (res)=>{
         console.log(res);
      }));
      return () => {
        dispatch(updateInitialState());
        messageSubscription.unsubscribe();
      };
  }, []);

  useEffect(() => {
    simpleGTMDataLayer({
            csrId: user.userName,
      event: `Conversation-Control-Tabs-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Tab click in conversation control page`,
      event_value: `${itemLabels[activeIndex]} tab selected by ${user.fullName}.`
    });
    simpleGTMDataLayer({
            csrId: user.userName,
      event: `Conversation-Control-Tabs-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Tab click in conversation control page`,
      event_value: `${itemLabels[activeIndex]} tab selected by ${user.fullName}.`
    });
  }, [activeIndex])

  const subscribeToMessage = () => {
    messageSubscription = executeGraphqlSubscribe(
      receiveMessagesSubscription
    ).subscribe({      next: ({ provider, value }: any) => {
        let messageResponse = value?.data?.onCreateMessageByAdjusterId;
          if (messageResponse.message) {
            let type = twoStringsAreEqual(user?.email, messageResponse?.from.id)
              ? SEND
              : RECEIVED;
            let newMsgDetails = {
              type: type,
              conversationId: messageResponse?.conversationId,
              fromId: messageResponse?.from.id
            };          
             if(type===RECEIVED){
              dispatch(fetchUnreadMessagesCountById(messageResponse?.conversationId));
              setAlert(newMsgDetails);
            }

          }
      },
      error: ({ error, provider }: any) => {
        handleSubscriptionError(error);
      },
    });
  };

  function onChange(newActiveIndex: number) {
    setActiveIndex(newActiveIndex)
  }

  const getComponent = () => {
    switch (activeIndex) {
      case 0:
        return <MyConversations />
      case 1:
        return <AllConversations />
      default:
        return <MyConversations />
    }
  }

  return (
    <Container data-testid="test-conversation-control">
      <TabBar activeIndex={activeIndex} itemLabels={itemLabels} onChange={onChange} />
      {getComponent()}
    </Container >
  )
}
